import React from 'react';
import { TableCell } from '../TableCell';
import { TextMarker } from '../../../../_lib/components/TextMarker/TextMarker';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type TableCellPhone = {
  label: string;
  url?: string;
  name?: string;
  cellProperties?: TableCell;
};
export function TableCellPhone({ label, cellProperties, url, name }: TableCellPhone) {
  const { t } = useSonTranslation('Table');

  return (
    <TableCell {...cellProperties} dataHead={label}>
      {name && (
        // associated label is in textmarker, which never returns null here
        <a href={url} className="tables__link" title={t('generators.phoneGenerator.title', { name })}>
          <TextMarker text={name} />
        </a>
      )}
    </TableCell>
  );
}
